import type { FC } from "react";

interface NavSearchCarouselProps {
  dyRecSelector?: string | null;
  condensed?: boolean;
}

// This file is being shadowed in the gatsby-site repo
// Returned null to prevent showing on /blog
export const NavSearchCarousel: FC<NavSearchCarouselProps> = () => null;
